"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Favorite_1 = require("./icons/Favorite");
var FavoriteOutline_1 = require("./icons/FavoriteOutline");
var spotify_1 = require("../spotify");
var styles_1 = require("../styles");
var Wrapper = styles_1.styled('div')({
    alignItems: 'center',
    display: 'flex',
    textAlign: 'left',
    '@media (max-width: 1023px)': {
        borderBottom: '1px solid #ccc',
        display: 'none',
        width: '100%',
    },
    '&.rswp__active': {
        '@media (max-width: 1023px)': {
            display: 'flex',
        },
    },
}, function (_a) {
    var style = _a.style;
    return ({
        height: styles_1.px(style.h),
        img: {
            height: styles_1.px(style.h),
            width: styles_1.px(style.h),
        },
    });
}, 'InfoRSWP');
var Title = styles_1.styled('div')({
    paddingLeft: styles_1.px(10),
    whiteSpace: 'nowrap',
    p: {
        fontSize: styles_1.px(14),
        lineHeight: 1.3,
        paddingRight: styles_1.px(5),
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        '&:first-child': {
            alignItems: 'center',
            display: 'inline-flex',
        },
    },
    span: {
        display: 'inline-block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    button: {
        fontSize: '110%',
        marginLeft: styles_1.px(5),
    },
}, function (_a) {
    var style = _a.style;
    return ({
        width: "calc(100% - " + styles_1.px(style.h) + ")",
        p: {
            color: style.trackNameColor,
            '&:last-child': {
                color: style.trackArtistColor,
            },
        },
        button: {
            color: style.c,
            '&.rswp__active': {
                color: style.activeColor,
            },
        },
    });
});
var Info = /** @class */ (function (_super) {
    __extends(Info, _super);
    function Info(props) {
        var _this = _super.call(this, props) || this;
        _this.isActive = false;
        _this.handleClickIcon = function () { return __awaiter(_this, void 0, void 0, function () {
            var isSaved, _a, onFavoriteStatusChange, token, track;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isSaved = this.state.isSaved;
                        _a = this.props, onFavoriteStatusChange = _a.onFavoriteStatusChange, token = _a.token, track = _a.track;
                        if (!isSaved) return [3 /*break*/, 2];
                        return [4 /*yield*/, spotify_1.removeTracks(token, track.id)];
                    case 1:
                        _b.sent();
                        this.updateState({ isSaved: false });
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, spotify_1.saveTracks(token, track.id)];
                    case 3:
                        _b.sent();
                        this.updateState({ isSaved: true });
                        _b.label = 4;
                    case 4:
                        onFavoriteStatusChange(!isSaved);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.setStatus = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, onFavoriteStatusChange, token, track, updateSavedStatus, status, _b, isSaved;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.isActive) {
                            return [2 /*return*/];
                        }
                        _a = this.props, onFavoriteStatusChange = _a.onFavoriteStatusChange, token = _a.token, track = _a.track, updateSavedStatus = _a.updateSavedStatus;
                        if (updateSavedStatus && track.id) {
                            updateSavedStatus(function (newStatus) {
                                _this.updateState({ isSaved: newStatus });
                            });
                        }
                        return [4 /*yield*/, spotify_1.checkTracksStatus(token, track.id)];
                    case 1:
                        status = _c.sent();
                        _b = __read(status || [false], 1), isSaved = _b[0];
                        this.updateState({ isSaved: isSaved });
                        onFavoriteStatusChange(isSaved);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.updateState = function (state) {
            if (state === void 0) { state = {}; }
            if (!_this.isActive) {
                return;
            }
            _this.setState(state);
        };
        _this.state = {
            isSaved: false,
        };
        return _this;
    }
    Info.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, showSaveIcon, track;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isActive = true;
                        _a = this.props, showSaveIcon = _a.showSaveIcon, track = _a.track;
                        if (!(showSaveIcon && track.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setStatus()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Info.prototype.componentDidUpdate = function (previousProps) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, showSaveIcon, track;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, showSaveIcon = _a.showSaveIcon, track = _a.track;
                        if (!(showSaveIcon && previousProps.track.id !== track.id && track.id)) return [3 /*break*/, 2];
                        this.updateState({ isSaved: false });
                        return [4 /*yield*/, this.setStatus()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Info.prototype.componentWillUnmount = function () {
        this.isActive = false;
    };
    Info.prototype.render = function () {
        var isSaved = this.state.isSaved;
        var _a = this.props, isActive = _a.isActive, showSaveIcon = _a.showSaveIcon, _b = _a.styles, activeColor = _b.activeColor, color = _b.color, height = _b.height, trackArtistColor = _b.trackArtistColor, trackNameColor = _b.trackNameColor, track = _a.track;
        var icon;
        /* istanbul ignore else */
        if (showSaveIcon && track.id) {
            icon = (React.createElement("button", { className: isSaved ? 'rswp__active' : undefined, onClick: this.handleClickIcon, type: "button" }, isSaved ? React.createElement(Favorite_1.default, null) : React.createElement(FavoriteOutline_1.default, null)));
        }
        var classes = [];
        if (isActive) {
            classes.push('rswp__active');
        }
        return (React.createElement(Wrapper, { className: classes.join(' '), style: { h: height } },
            track.image && React.createElement("img", { alt: track.name, src: track.image }),
            React.createElement(Title, { style: { c: color, h: height, activeColor: activeColor, trackArtistColor: trackArtistColor, trackNameColor: trackNameColor } },
                React.createElement("p", null,
                    React.createElement("span", null, track.name),
                    icon),
                React.createElement("p", null, track.artists))));
    };
    return Info;
}(React.PureComponent));
exports.default = Info;
//# sourceMappingURL=Info.js.map